// extracted by mini-css-extract-plugin
module.exports = {"container":"Approval_container__3QCgg","approvals":"Approval_approvals__2oX6B"};